import { Mutation } from 'app/types/mutation'
import { gql } from 'graphql-request'

export const newsletterSubscribeMutation = () => gql`
  mutation newsletterSubscribe($email: String!) {
    newsletterSubscribe(email: $email) {
      id
      success
      reason
    }
  }
`

export const newsletterSubscribeResult = (data: any) => {
  return data.newsletterSubscribe as Mutation
}
